'use client'

import { X } from 'lucide-react'
import { useEffect, useRef } from 'react'

export default function MyCartModal({ open, onClose }: { open: boolean, onClose: () => void }) {
  const modalRef = useRef<HTMLDivElement>(null)

  // Close on outside click
  useEffect(() => {
    if (!open) return
    function handleClick(e: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <div
        ref={modalRef}
        className="bg-white rounded-2xl p-6 max-w-xs w-full text-center relative animate-slide-up"
      >
        <button
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 rtl:left-4 rtl:right-auto"
          onClick={onClose}
        >
          <X className="w-6 h-6" />
        </button>
        <div className="flex flex-col items-center justify-center mt-2 mb-4">
          <div className="bg-[#EFFFF6] rounded-full w-16 h-16 flex items-center justify-center mb-10">
            <span className="text-4xl text-green-600 font-bold">%</span>
          </div>
          <h3 className="font-bold text-xl mb-2">You’ve saved <span className="text-green-600">₹1073.51</span> on this order.</h3>
          <div className="text-gray-600 text-sm mb-2">You&apos;ve unlocked a special price. enjoy your savings!</div>
          <strong className="text-[#fd5100] text-lg mt-6">YAY!</strong>
        </div>
      </div>
    </div>
  )
}